// extracted by mini-css-extract-plugin
export default {"smallHead":"HomePage_smallHead__Gkoit","smallHeadTyped":"HomePage_smallHeadTyped__5J0Hy","largeHead":"HomePage_largeHead__8z3IX","wheelSvg":"HomePage_wheelSvg__A5HJ9"};